import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ClipboardService } from 'ngx-clipboard';
import { NgxSpinnerService } from 'ngx-spinner';
import { DwoAppointemntSubCheckListViewModel } from 'projects/Administration/src/app/business-entities/dwo-sub-check-list-detail-view-model';
import { DWOCheckListRequestModel } from 'projects/Administration/src/app/business-entities/dwo-sub-check-list-view-model';
import { EditAppointmentService } from 'projects/Administration/src/app/business-services/edit-appointment.service';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { Subscription } from 'rxjs';
import { DwoCheckListBusinessService } from './../../../../../../../business-services/dwo-checklist.service';
import * as fromEnums from './../../../../../../../../../../Autofacets-Core/src/app/utils/enums';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { DwoDiagnoseBusinessService } from 'projects/Administration/src/app/business-services/dwo-diagnose.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import * as Enums from 'projects/Autofacets-Core/src/app/utils/enums';
@Component({
  selector: 'app-dwo-checklist',
  templateUrl: './dwo-checklist.component.html',
  styleUrls: ['./dwo-checklist.component.css'],
})
export class DwoChecklistComponent implements OnInit {
  @Input() isFromArchive: boolean | undefined;
  currentlagSub: Subscription;
  lstPredefinedColors = Constant.PredefinedColors;
  response: DwoAppointemntSubCheckListViewModel[];
  requestModel: DWOCheckListRequestModel = {
    clType: null,
    langCode: '',
    appointmentDemandId: 1,
    appointmentGuid: null,
  };
  isEdit: boolean;
  isFromArchiveFlag: boolean=false;
  appointmentGuid: string;
  isColorCoded: boolean;
  editCheckListForm: FormGroup;
  @Output() updatedData: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private dwoservice: DwoCheckListBusinessService,
    private readonly editAppointmentService: EditAppointmentService,
    private currentLanguageService: CurrentLanguage,
    private spinner: NgxSpinnerService,
    private clipboardApi: ClipboardService,
    private formBuilder: FormBuilder,
    private service: DwoDiagnoseBusinessService,
    private translate: TranslateService,
    private toaster: ToastrService
  ) {}

  ngOnInit(): void {
    if (this.isFromArchive !== undefined) {
      this.isFromArchiveFlag = this.isFromArchive;
    }
    this.isEdit = this.editAppointmentService.isEdit;
    //Check for historical WO tab -> If true then appointmentGuid will be of selected WO.
    if (
      this.editAppointmentService.isFromHistoricalWOTab ||
      this.editAppointmentService.isFromVehicleHistoricalTab
    ) {
      this.appointmentGuid =
        this.editAppointmentService.appointmentGuidOfSelectedWO;
    } else {
      this.appointmentGuid =
        this.editAppointmentService.appointmentDetails.appointmentGuid;
    }

    this.currentlagSub = this.currentLanguageService.currentLanguage.subscribe(
      (x) => {
        this.requestModel.langCode = x;
        this.requestModel.appointmentGuid = this.appointmentGuid;
        this.requestModel.clType = fromEnums.ClType.Generic;

        this.getAppointmentCheckList(this.requestModel);
      }
    );
    this.editCheckListForm = this.formBuilder.group({
      dynamicFields: this.formBuilder.array([]),
    })
  }
  getAppointmentCheckList(model: DWOCheckListRequestModel) {
    this.spinner.show();
    this.dwoservice.getCheckList(model).then((res) => {
      this.response = res.responseObject;
      this.isColorCoded = this.response?.some(
        (item) => item.isMulticolorCheckListSelected
      );
      this.response.forEach(element => {
        element.checkListItems = element.checkListItems.filter(x => x.isQuestionActive);
      });
      this.response.forEach(data => {
        data.checkListItems.forEach(element =>{
          this.addDynamicField(element.id,"textAnswer",element.textBoxValue);
          element.checkListItemType?.forEach(item =>{
            this.addDynamicField(item.id,"checkAnswer",item.checkBoxValue);
          });
          element.checkListRadioItemType?.forEach(item =>{
            this.addDynamicField(item.id,"radioAnswer",item.radioButtonValue);
          })
        })
      })
    });
    this.spinner.hide();
  }

  addDynamicField(id:number,type:string,value:any) {
    const dynamicFieldsArray = this.editCheckListForm.get('dynamicFields') as FormArray;
    dynamicFieldsArray.push(this.formBuilder.group({ id: [id],[type]: [value]}));
  }

  updateDynamicFieldValue(id:number, newValue: any,type:string,option: any) {
    const dynamicFieldsArray = this.editCheckListForm.get('dynamicFields') as FormArray;
    const index = dynamicFieldsArray.controls.findIndex(control => control.get('id').value === id);
    const fieldControl = dynamicFieldsArray.at(index).get(type) as FormControl;
    fieldControl.patchValue(newValue);
    if(type == 'radioAnswer'){
      let list = option?.filter(x => x.id != id);
      list?.forEach((x) =>{
        const index = dynamicFieldsArray.controls.findIndex(control => control.get('id').value === x.id);
        const fieldControl = dynamicFieldsArray.at(index).get(type) as FormControl;
        fieldControl.patchValue(false);
      })
    }
  }

  copyTextDetail(copyText:string){
    this.clipboardApi.copyFromContent(copyText)
  }
  
  onSave(updatedData:any){
    this.spinner.show();
    let successMessage = this.translate.instant('lblDWOData');
    let errorMessage = this.translate.instant("lblErrorMessage");

    let checkListdata = {
      "AppointmentId": this.editAppointmentService.appointmentDetails.appointmentId,
      "LangCode": this.response[0].langCode,
      "ClType": 1,
      "DwoCheckListAppointmentAnswers": this.editCheckListForm.value.dynamicFields
    }
    this.service.SaveCheckList(checkListdata).then((res)=>{
      if (res.responseCode == Enums.ErrorCodes.SuccessCode) {
        this.spinner.hide();
        this.toaster.success(successMessage);
      }
      else{
        this.spinner.hide();
        this.toaster.error(errorMessage);
      }
    })
  }
  Cancelform(flag: string) {
    this.editCheckListForm.disable();
  }
} 
